import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faCheckCircle, 
  faGlobe, 
  faUsers, 
  faMoneyBillWave, 
  faChartLine, 
  faPuzzlePiece 
} from "@fortawesome/free-solid-svg-icons";

const FeaturekeySection = () => {
  const features = [
    { id: 1, icon: faCheckCircle, text: "Compliance Management: Ensure adherence to local labor laws, tax regulations, and statutory requirements." },
    { id: 2, icon: faGlobe, text: "Multi-Country Payroll: Process payroll in local currencies with automatic tax calculations and compliance checks." },
    { id: 3, icon: faUsers, text: "Employee Classification: Support for full-time employees, contractors, and freelancers." },
    { id: 4, icon: faMoneyBillWave, text: "Multi-Currency Payments: Pay employees and contractors in their preferred currencies." },
    { id: 5, icon: faChartLine, text: "Custom Reports: Access detailed payroll reports for data-driven decisions." },
    { id: 6, icon: faPuzzlePiece, text: "Integration: Seamless integration with HR and accounting tools." },
  ];

  return (
    <section id="features" className="features-section">
      <h2 className="features-title">Key Features of the Service</h2>
      <div className="features-grid">
        {features.map((feature) => (
          <div key={feature.id} className="feature-item">
            <FontAwesomeIcon icon={feature.icon} className="feature-icon" />
            <p className="feature-text">{feature.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeaturekeySection;
